const BLOCK_2: RegExp[] = [/[0-9]/, /[0-9]/];
const BLOCK_3: RegExp[] = [/[0-9]/, /[0-9]/, /[0-9]/];
const BLOCK_4: RegExp[] = [/[0-9]/, /[0-9]/, /[0-9]/, /[0-9]/];

const BLOCK_2_ALPHA: RegExp[] = [/[A-Z0-9]/i, /[A-Z0-9]/i];
const BLOCK_3_ALPHA: RegExp[] = [/[A-Z0-9]/i, /[A-Z0-9]/i, /[A-Z0-9]/i];
const BLOCK_4_ALPHA: RegExp[] = [/[A-Z0-9]/i, /[A-Z0-9]/i, /[A-Z0-9]/i, /[A-Z0-9]/i];

const CPF_LENGTH: number = 11;

export const cpfMask: (RegExp | string)[] = [
  ...BLOCK_3, '.', ...BLOCK_3, '.', ...BLOCK_3, '-', ...BLOCK_2
];

export const cnpjMask: (RegExp | string)[] = [
  ...BLOCK_2, '.', ...BLOCK_3, '.', ...BLOCK_3, '/', ...BLOCK_4, '-', ...BLOCK_2
];

const alphanumericMask: (RegExp | string)[] = [
  ...BLOCK_2_ALPHA, '.', ...BLOCK_3_ALPHA, '.', ...BLOCK_3_ALPHA, '/', ...BLOCK_4_ALPHA, '-', ...BLOCK_2
];

export function cpfCnpjMask(userInput: string): (RegExp | string)[] {
  let cleanInput = (userInput || '').replace(/[^A-Za-z0-9]/g, '');
  cleanInput = cleanInput.toUpperCase();
  const numbers = cleanInput.replace(/\D/g, '');
  const hasLetters = /[A-Z]/.test(cleanInput);

  if (hasLetters) {
    return alphanumericMask;
  }

  return numbers.length <= CPF_LENGTH ? cpfMask : cnpjMask;
}

